var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgE1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:bitcoin"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.24 10.56C13.93 11.8 12 11.17 11.4 11L11.95 8.82004C12.57 9.00004 14.56 9.26004 14.24 10.56ZM11.13 12.12L10.53 14.53C11.27 14.72 13.56 15.45 13.9 14.09C14.26 12.67 11.87 12.3 11.13 12.12ZM21.7 14.42C20.36 19.78 14.94 23.04 9.58 21.7C4.22 20.36 0.963001 14.94 2.3 9.58004C2.61764 8.30613 3.18313 7.10727 3.96417 6.05194C4.74521 4.99661 5.72649 4.10547 6.85198 3.42944C7.97747 2.7534 9.22511 2.30571 10.5236 2.11192C11.8222 1.91814 13.1462 1.98206 14.42 2.30004C19.77 3.64004 23.03 9.06004 21.7 14.42ZM14.21 8.05004L14.66 6.25004L13.56 6.00004L13.12 7.73004C12.83 7.66004 12.54 7.59004 12.24 7.53004L12.68 5.76004L11.59 5.50004L11.14 7.29004C10.9 7.23004 10.66 7.18004 10.44 7.12004L8.93 6.74004L8.63 7.91004C8.63 7.91004 9.45 8.10004 9.43 8.11004C9.88 8.22004 9.96 8.50004 9.94 8.75004L8.71 13.68C8.66 13.82 8.5 14 8.21 13.95C8.22 13.96 7.41 13.75 7.41 13.75L6.87 15L8.29 15.36C8.56 15.43 8.82 15.5 9.08 15.56L8.62 17.38L9.72 17.66L10.17 15.85C10.47 15.93 10.76 16 11.04 16.08L10.59 17.87L11.69 18.15L12.15 16.33C14 16.68 15.42 16.54 16 14.85C16.5 13.5 16 12.7 15 12.19C15.72 12 16.26 11.55 16.41 10.57C16.61 9.24004 15.59 8.53004 14.21 8.05004Z",
    fill: "#15318D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgE1);
export default __webpack_public_path__ + "static/media/e1.d11366a2b93d2a8674b9ac4c4c70ab85.svg";
export { ForwardRef as ReactComponent };